import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { IconButton } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Radio, RadioGroup,TextField ,FormLabel,FormControlLabel} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { formatDateDDMMYYYY } from "utils/dateFormatter";
import "../styles/form-labels.css";

function CreateCareCoordinators() {
  const [formErrors, setFormErrors] = useState({
  firstname: "",
  lastname: "",
  username: "",
  phoneNumber: "",
  nuid: "",
  nuidstatus: "",
  dob: "",
  locationid: "",
  gender: "",
  martialStatus: "",
  certificationvalidtill: "",
});
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState("");
  const [devicename, setDevicename] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [devices, setDevices] = useState([]);
  const [showCustomFields, setShowCustomFields] = useState(false);
  const [customerTypes, setCustomerTypes] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldData, setCustomFieldData] = useState({});
  const [showDocuments, setShowDocuments] = useState(false);
   const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
 const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
  const [customerDetails, setCustomerDetails  ] = useState({
    username: "",
    role: "",
    coordinator: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phoneNumber: "",
       countryCode: "+91",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     certificationvalidtill:"",
     dob:"",
     nuid:"",
     nuidstatus:"",
    },
    document:[
     {
      documentname: "",
      documenttype: "",
    dateofupload: getCurrentDate(),
      imageMeta: "",
      image: "",
    },
    ],
  });
 const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
const countryPhoneRules = {
  "+91": 10, // India
  "+1": 10,  // USA / Canada
  "+44": 10, // UK
  "+61": 9,  // Australia
  "+971": 9, // UAE
};
const countryPhonePatterns = {
  "+91": /^[6-9]\d{9}$/, // India: must start with 6–9 and be 10 digits
  "+1": /^[2-9]\d{9}$/,  // USA: first digit cannot be 0 or 1
  "+44": /^\d{10}$/,     // UK: 10 digits
  "+61": /^\d{9}$/,      // Australia: 9 digits
  "+971": /^\d{9}$/,     // UAE: 9 digits
};

const validateNUID = (nuid) => {
  const regex = /^[A-Za-z0-9]+$/;
  return regex.test(nuid.trim());
};

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
const validatePhoneNumber = (phone) => {
  const regex = /^[0-9]{10}$/; // exactly 10 digits
  return regex.test(phone.trim());
};
  const handleAddDocument = () => {
  setCustomerDetails((prev) => ({
    ...prev,
    document: [
      ...prev.document,
      {
        documentname: "",
        documenttype: "",
        dateofupload: "",
        imageMeta: "",
        image: "",
      },
    ],
  }));
};

useEffect(() => {
  const fetchLocations = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get("/api/location", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setLocations(decrypted); // save locations in state
      }
    } catch (err) {
      console.error("Failed to fetch locations", err);
    }
  };

  fetchLocations();
}, []);

  const [customersList, setCustomersList] = useState([]);  
  const navigate = useNavigate();
 const validateForm = () => {
  const errors = {};

    const code = customerDetails.coordinator?.countryCode || "+91";
  const phone = customerDetails.coordinator?.phoneNumber?.trim() || "";

  const { coordinator, username } = customerDetails;


 const nameRegex = /^[A-Za-z\s]+$/;
  const usernameRegex = /^[a-zA-Z0-9_]+$/;
 const countryPhonePatterns = {
    "+91": /^[6-9]\d{9}$/, // India
    "+1": /^[2-9]\d{9}$/,  // USA
    "+44": /^\d{10}$/,     // UK
    "+61": /^\d{9}$/       // Australia
  };

  const countryPhoneRules = {
    "+91": 10,
    "+1": 10,
    "+44": 10,
    "+61": 9
  };

  const expectedLength = countryPhoneRules[code] || 10;
  const pattern = countryPhonePatterns[code];
  if (!phone) {
    errors.phoneNumber = "Phone number is required";
  } else if (!/^\d+$/.test(phone)) {
    errors.phoneNumber = "Phone number must contain only digits";
  } else if (phone.length !== expectedLength) {
    errors.phoneNumber = `Invalid phone number length for ${code}. Expected ${expectedLength} digits.`;
  } else if (pattern && !pattern.test(phone)) {
    errors.phoneNumber = `Invalid phone number format for ${code}`;
  } else if (!pattern && (phone.length < 6 || phone.length > 15)) {
    errors.phoneNumber = `Invalid phone number format for ${code}`;
  }

  // ✅ Country code validation
  if (!coordinator.countryCode || coordinator.countryCode.trim() === "") {
    errors.phoneNumber = "Country code is required";
  }

 if (!coordinator || !coordinator.firstname || !coordinator.firstname.trim()) {
    errors.firstname = "First Name is required";
  } else if (!nameRegex.test(coordinator.firstname.trim())) {
    errors.firstname = "First Name should contain only alphabets (no numbers or special characters)";
  } else if (coordinator.firstname.trim().length < 2) {
    errors.firstname = "First Name must be at least 2 characters long";
  }

  // --- Last Name ---
  if (!coordinator || !coordinator.lastname || !coordinator.lastname.trim()) {
    errors.lastname = "Last Name is required";
  } else if (!nameRegex.test(coordinator.lastname.trim())) {
    errors.lastname = "Last Name should contain only alphabets (no numbers or special characters)";
  }
if (!username.trim()) {
  errors.username = "Email is required";
} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
  errors.username = "Invalid email format";
}
 

   if (!coordinator.nuid.trim()) errors.nuid = "NUID is required";
  else if (!validateNUID(coordinator.nuid)) errors.nuid = "Invalid NUID format";
  if (!coordinator.nuidstatus.trim()) errors.nuidstatus = "NUID status is required";
 if (!coordinator.dob.trim()) {
    errors.dob = "Date of Birth is required";
  } else {
    const dob = new Date(coordinator.dob);
    const today = new Date();
    if (dob > today) {
      errors.dob = "Date of Birth cannot be in the future";
    }
  }
  if (!coordinator.locationid) errors.locationid = "Location is required";
  if (!coordinator.gender.trim()) errors.gender = "Gender is required";
  if (!coordinator.martialStatus.trim()) errors.martialStatus = "Marital Status is required";
 if (!coordinator.certificationvalidtill.trim()) {
    errors.certificationvalidtill = "Certification validity date is required";
  } else {
    const certDate = new Date(coordinator.certificationvalidtill);
    const today = new Date();

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    if (certDate < oneYearAgo) {
      errors.certificationvalidtill = "Certification validity expired long back — please update";
    }
  }
  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};
const validateDocuments = () => {
  let hasError = false;
  const updatedDocs = [...customerDetails.document];

  // Check duplicates
  const docNames = updatedDocs.map((d) => d.documentname);
  const duplicates = docNames.filter((item, index) => docNames.indexOf(item) !== index);
  if (duplicates.length > 0) {
    toast.error(`Duplicate document uploaded: ${duplicates[0]}`);
    hasError = true;
  }

  const requiredDocs = ["Aadhar Card", "Pan Card", "Driving License", "Study Certificate"];
  requiredDocs.forEach((docName) => {
    let doc = updatedDocs.find((d) => d.documentname === docName);
    let idx = updatedDocs.findIndex((d) => d.documentname === docName);

    if (!doc) {
      doc = { documentname: docName, documenttype: "", dateofupload: "", image: "", errors: {} };
      updatedDocs.push(doc);
      idx = updatedDocs.length - 1;
    }

    const errors = {};
    // if (!doc.documenttype) errors.documenttype = "Document Type is required";
    // if (!doc.dateofupload) errors.dateofupload = "Date of Upload is required";
    if (!doc.image) errors.image = "File upload is required";

    if (Object.keys(errors).length > 0) {
      toast.error(`${docName} is required with File.`);
      hasError = true;
    }

    updatedDocs[idx].errors = errors;
  });

  setCustomerDetails({ ...customerDetails, document: updatedDocs });
  return !hasError;
};

 const handleSubmit = async (e) => {
  
  e.preventDefault();

  const isFormValid = validateForm();
  const areDocsValid = validateDocuments();

  if (isFormValid !== true || areDocsValid !== true) {
    console.log("❌ Validation failed. Stopping API trigger.");
    toast.error("Please fix the errors highlighted in red.");
    return; // 🚫 STOP here — API will never trigger
  }

  console.log("✅ Validation passed. Proceeding with API...");

  setLoading(true);
    try {
      
      const secretKey = await fetchSecretKey();
    
      
      const rawPayload = {
        username: customerDetails.username,
        role: "ROLE_CARE_COORDINATOR",

        coordinator: {

          firstname: customerDetails.coordinator.firstname,
          lastname: customerDetails.coordinator.lastname,
          imageMeta: customerDetails.coordinator.imageMeta,
    image: customerDetails.coordinator.image,
      phoneNumber: `${customerDetails.coordinator.phoneNumber}`, // country first
      phonecountrycode:`${customerDetails.coordinator.countryCode}`,
    locationid: customerDetails.coordinator.locationid,
    age: customerDetails.coordinator.age,
    martialStatus: customerDetails.coordinator.martialStatus,
    gender: customerDetails.coordinator.gender,
    certificationvalidtill: formatDateDDMMYYYY(customerDetails.coordinator.certificationvalidtill),
    dob: formatDateDDMMYYYY(customerDetails.coordinator.dob),
    nuid: customerDetails.coordinator.nuid,
    nuidstatus: customerDetails.coordinator.nuidstatus,
         
        },
document: customerDetails.document?.map((doc) => ({
    documentname: doc.documentname,
    documenttype: doc.documenttype,
   dateofupload: formatDateDDMMYYYY(doc.dateofupload ? doc.dateofupload : currentDate),
    imageMeta: doc.imageMeta,
    image: doc.image,
  })),

      };
  
      console.log("Raw Payload Before Encryption:", rawPayload); 
  
      const encryptedData = encryptBody(rawPayload, secretKey);
  
      console.log("Encrypted Payload:", encryptedData);
  
      const token = JSON.parse(localStorage.getItem("loginData")).token;
  
      // Register Dealer
      const response = await axios.post("/api/carecoordinator/register", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);

  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
  
        if (decryptedResponse.success === true) {
          
          toast.success(decryptedResponse.message || "Care Coordinator Profile Created successfully!");
          navigate(-1);
          setTimeout(() => {
            toast.info("Password has been sent to your email.");
          }, 1500);
          const dealerid = decryptedResponse?.dealerid; 
  
          // if (dealerid && deviceId) {
          //   await mapDealerToDevice(dealerid, deviceId, token);
          // }
  
          // Reset the form and update UI
          setCustomersList
((prevDealers) => [
            ...prevDealers,
            {
             firstname: customerDetails.coordinator.firstname,
          lastname: customerDetails.coordinator.lastname,
          imageMeta: customerDetails.coordinator.imageMeta,
    image: customerDetails.coordinator.image,
    phoneNumber: customerDetails.coordinator.phoneNumber,
    locationid: customerDetails.coordinator.locationid,
    age: customerDetails.coordinator.age,
    martialStatus: customerDetails.coordinator.martialStatus,
    gender: customerDetails.coordinator.gender,
    certificationvalidtill: customerDetails.coordinator.certificationvalidtill,
    dob: customerDetails.coordinator.dob,
    nuid: customerDetails.coordinator.nuid,
    nuidstatus: customerDetails.coordinator.nuidstatus,
         
            },
          ]);
  
          setCustomerDetails
({
            username: "",
    role: "",
    coordinator: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phoneNumber: "",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     certificationvalidtill:"",
     dob:"",
     nuid:"",
     nuidstatus:"",
    },
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: "",
      imageMeta: "",
      image: "",
    },
    ],
          });
  

        } else {
          toast.error(decryptedResponse?.message || "Failed to verify registration.");
        }
      }
   } catch (error) {
  console.error("Registration Error:", error);

  let errorMessage = "Registration failed"; // default message

  if (error.response) {
    const data = error.response.data;

    // ✅ If backend sends a structured JSON with a 'message' field
    if (typeof data === "object" && data.message) {
      errorMessage = data.message;
    } 
    // ✅ If backend sends a plain text message
    else if (typeof data === "string") {
      errorMessage = data;
    }
  } 
  // ✅ For network or other unexpected errors
  else if (error.message) {
    errorMessage = error.message;
  }

  toast.error(errorMessage);
} finally {
  setLoading(false);
}
  };
  
  
 

  

 
  const handleCancel = () => {
    setCustomerDetails
({
     username: "",
    role: "",
    coordinator: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phoneNumber: "",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     certificationvalidtill:"",
     dob:"",
     nuid:"",
     nuidstatus:"",
    },
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: "",
      imageMeta: "",
      image: "",
    },
    ],
    });
    navigate(-1); 
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                                           backgroundColor: "#2e7faeff",

                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      

     

        
        <Card sx={{ width: "1200px", maxWidth: "1200px", padding: 3 }}>
          <MDBox pt={4} pb={3} px={3}>
            
            <form onSubmit={handleSubmit}>
            <MDTypography  sx={{  marginBottom: "20px",   textAlign: "center",fontSize: "15px", fontWeight: "bold", marginBottom: "10px" }}>Care Coordinator</MDTypography>

              <Grid container spacing={2}>

                {/* Profile Photo Upload */}
<Grid item xs={12} style={{ textAlign: "center" }}>
  {customerDetails.coordinator?.image && (
    <img
      src={`data:image/*;base64,${customerDetails.coordinator.image}`}
      alt="Profile Preview"
      style={{
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        objectFit: "cover",
        marginBottom: "10px",
      }}
    />
  )}

  {/* Upload Button */}
  <input
    accept="image/*"
    style={{ display: "none" }}
    id="upload-profile-photo"
    type="file"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setCustomerDetails({
            ...customerDetails,
            coordinator: {
              ...customerDetails.coordinator,
              imageMeta: file.name,
              image: reader.result.split(",")[1], // base64
            },
          });
        };
        reader.readAsDataURL(file);
      }
    }}
  />
  <br/>
  <label htmlFor="upload-profile-photo">
    <MDButton
      component="span"
      style={{
        backgroundColor: "#2e7faeff",
        color: "#fff",
        textTransform: "none",
        minWidth: "160px",   // reduced length
        height: "36px",
      }}
    >
      Upload Profile Photo
    </MDButton>
  </label>
</Grid>
             <Grid item xs={6}>
  <MDInput
    type="text"
    label="Nursing Unique Identification Number "
    fullWidth
    value={customerDetails.coordinator?.nuid}
    onChange={(e) => {
      const newValue = e.target.value.toUpperCase();
      setCustomerDetails({
        ...customerDetails,
        coordinator: { ...customerDetails.coordinator, nuid: newValue },
      });
    }}
    onBlur={() => {
      const nuid = customerDetails.coordinator?.nuid || "";
      if (nuid && !validateNUID(nuid)) {
        toast.error("Invalid NUID format.");
      }
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <MDButton
            onClick={() =>
              window.open("https://nrts.indiannursingcouncil.gov.in/login.nic", "_blank")
            }
            style={{
              backgroundColor: "#2e7faeff",
              color: "#fff",
              minWidth: "60px",
              height: "5px",
              fontSize: "12px",
              padding: "0px 4px",
              lineHeight: "1",
            }}
          >
            Verify
          </MDButton>
        </InputAdornment>
      ),
    }}
    
  />
   {formErrors.nuid && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.nuid}
  </Typography>
)}
</Grid>

        <Grid item xs={6}>
  <MDInput
    select
    label="Nursing Unique Identification Status"
    fullWidth
    value={customerDetails.coordinator?.nuidstatus || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        coordinator: { ...customerDetails.coordinator, nuidstatus: e.target.value },
      })
    }
     sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    
  >

    <MenuItem value="Active">Active</MenuItem>
    <MenuItem value="Pending">Pending</MenuItem>
  
  </MDInput>
   {formErrors.nuidstatus && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.nuidstatus}
  </Typography>
)}
</Grid>  
        <Grid item xs={6}>
          <MDInput
            type="text"
            label="First Name"
            fullWidth
            value={customerDetails.coordinator?.firstname}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, coordinator: { ...customerDetails.coordinator, firstname: e.target.value } })
            }
            // required
            
          />
          {formErrors.firstname && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.firstname}
  </Typography>
)}
        </Grid>
         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Last Name"
            fullWidth
            value={customerDetails.coordinator?.lastname}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, coordinator: { ...customerDetails.coordinator, lastname: e.target.value } })
            }
            // required
            
          />
        </Grid>
        <Grid item xs={6}>
          <MDInput
            type="email"
            label="Email"
            fullWidth
            value={customerDetails?.username}
            onChange={(e) => setCustomerDetails
                ({ ...customerDetails, username: e.target.value })}
            // required
          />
          {formErrors.username && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.username}
  </Typography>
)}
        </Grid>
       <Grid item xs={6}>
  <Grid container spacing={1}>
    <Grid item xs={4}>
      <MDInput
        select
        label="Country Code"
        fullWidth
        value={customerDetails.coordinator?.countryCode || "+91"}
        onChange={(e) =>
          setCustomerDetails({
            ...customerDetails,
            coordinator: {
              ...customerDetails.coordinator,
              countryCode: e.target.value,
            },
          })
        }
        sx={{
          "& .MuiInputBase-root": {
            height: "45px",
          },
        }}
      >
        {countryCodes.map((item) => (
          <MenuItem key={item.code} value={item.code}>
            {`${item.name} (${item.code})`}
          </MenuItem>
        ))}
      </MDInput>
    </Grid>
        {/* Phone Number Input */}
    <Grid item xs={8}>
      <MDInput
        type="text"
        label="Phone Number"
        fullWidth
        value={customerDetails.coordinator?.phoneNumber || ""}
        onChange={(e) => {
      const code = customerDetails.coordinator?.countryCode || "+91";
      const maxLength = countryPhoneRules[code] || 10;
      const value = e.target.value.replace(/\D/g, ""); // only digits
      if (value.length <= maxLength) {
        setCustomerDetails({
          ...customerDetails,
          coordinator: {
            ...customerDetails.coordinator,
            phoneNumber: value,
          },
        });
      }
    }}
       onBlur={() => {
      const phone = customerDetails.coordinator?.phoneNumber || "";
      const code = customerDetails.coordinator?.countryCode || "+91";
      const expectedLength = countryPhoneRules[code] || 10;
      const pattern = countryPhonePatterns[code];

      if (phone.length !== expectedLength) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
        }));
      } else if (!pattern.test(phone)) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Invalid phone number format for ${code}`,
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, phoneNumber: "" }));
      }
    }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
 {formErrors.phoneNumber ? (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.phoneNumber}
  </Typography>
) : (
  <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
    {customerDetails.coordinator?.countryCode === "+91"
      ? "Enter a 10-digit Indian number (e.g., 9876543210)"
      : `Enter ${
          countryPhoneRules[customerDetails.coordinator?.countryCode || "+91"]
        } digits phone number for ${
          countryCodes.find(
            (c) => c.code === customerDetails.coordinator?.countryCode
          )?.name || "selected country"
        }`}
  </Typography>
)}

</Grid>
       
       <Grid item xs={6}>
  <MDInput
    select
    label="Location"
    fullWidth
    value={customerDetails.coordinator?.locationid || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        coordinator: {
          ...customerDetails.coordinator,
          locationid: e.target.value,
        },
      })
    }
     sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
  >
    {locations.map((loc) => (
       <MenuItem key={loc.id} value={loc.id}>
    {`${loc.address}, ${loc.city}, ${loc.state},  ${loc.country}, ${loc.pin},`}
  </MenuItem>
    ))}
  </MDInput>
   {formErrors.locationid && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.locationid}
  </Typography>
)}
</Grid>

       
       <Grid item xs={6}>
  <MDInput
    select
    label="Gender"
    fullWidth
    value={customerDetails.coordinator?.gender || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        coordinator: { ...customerDetails.coordinator, gender: e.target.value },
      })
    }
    // required
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
  >
    <MenuItem value="Male">Male</MenuItem>
    <MenuItem value="Female">Female</MenuItem>
    <MenuItem value="Others">Others</MenuItem>
  </MDInput>
   {formErrors.gender && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.gender}
  </Typography>
)}
</Grid>
      <Grid item xs={6}>
  <MDInput
    select
    label="Marital Status"
    fullWidth
    value={customerDetails.coordinator?.martialStatus || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        coordinator: { ...customerDetails.coordinator, martialStatus: e.target.value },
      })
    }
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    // required
  >
    <MenuItem value="Single">Single</MenuItem>
    <MenuItem value="Married">Married</MenuItem>
    <MenuItem value="Divorced">Divorced</MenuItem>
    <MenuItem value="Widowed">Widowed</MenuItem>
  </MDInput>
   {formErrors.martialStatus && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.martialStatus}
  </Typography>
)}
</Grid>
<Grid item xs={6}>
  <MDInput
    type="date"
    label="Date of Birth"
    fullWidth
    InputLabelProps={{ shrink: true }}
    value={customerDetails.coordinator?.dob || ""}
    onChange={(e) => {
      let dobValue = e.target.value;
      const [year, month, day] = dobValue.split("-");

      if (year && year.length > 4) {
        dobValue = `${year.slice(0, 4)}-${month || ""}-${day || ""}`;
      }

      const age = calculateAge(dobValue);
      setCustomerDetails({
        ...customerDetails,
        coordinator: { 
          ...customerDetails.coordinator, 
          dob: dobValue,
          age: isNaN(age) ? "" : age.toString()
        },
      });
    }}
    onKeyDown={(e) => e.preventDefault()}
  />
   {formErrors.dob && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.dob}
  </Typography>
)}
</Grid>

         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Age"
            fullWidth
             placeholder="Calculated from Date of Birth"
 InputProps={{
      readOnly: true,
    }}

  //   InputLabelProps={{
  //   style: {
  //     lineHeight: "1.4",
  //     marginTop:"-3px"
  //   },
  // }}
            value={customerDetails.coordinator?.age}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, coordinator: { ...customerDetails.coordinator, age: e.target.value } })
            }
            // required
                // helperText="This field is automatically calculated based on Date of Birth"

          />
        </Grid>
          <Grid item xs={6}>
          <MDInput
            type="date"
            label="Certification Valid Till"
            fullWidth
                InputLabelProps={{ shrink: true }}

            value={customerDetails.coordinator?.certificationvalidtill}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, coordinator: { ...customerDetails.coordinator, certificationvalidtill: e.target.value } })
            }
            // required
          />
           {formErrors.certificationvalidtill && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.certificationvalidtill}
  </Typography>
)}
        </Grid>
      
{/* --- Mandatory Documents Section --- */}
<Grid item xs={12}>
  <Typography
    variant="h6"
    sx={{ mt: 2, mb: 1, fontWeight: "bold", color: "#1e6a91" }}
  >
    Mandatory Documents
  </Typography>
</Grid>

{["Aadhar Card", "Pan Card", "Driving License", "Study Certificate"].map(
  (docName, index) => {
    const doc = customerDetails?.document[index] || {};
    const errors = doc.errors || {};

    return (
      <Grid container spacing={2} key={index} mt={1}>
        {/* Document Name (fixed & disabled) */}
        <Grid item xs={6}>
          <TextField
            label="Document Name"
            fullWidth
            value={docName}
            InputProps={{
        readOnly: true, 
      }}
            sx={{
              "& .MuiInputBase-root": { height: "45px" },
              backgroundColor: "#f9f9f9",
            }}
          />
        </Grid>

        {/* Document Type */}
        {/* <Grid item xs={6}>
          <MDInput
            label="Document Type"
            fullWidth
            value={doc.documenttype || ""}
            onChange={(e) => {
              const updatedDocs = [...customerDetails.document];
              updatedDocs[index] = {
                ...updatedDocs[index],
                documentname: docName,
                documenttype: e.target.value,
              };
              setCustomerDetails({
                ...customerDetails,
                document: updatedDocs,
              });
            }}
            error={!!errors.documenttype}
            helperText={errors.documenttype}
          />
          {errors.documenttype && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errors.documenttype}
            </Typography>
          )}
        </Grid> */}

        {/* Date of Upload */}
        {/* <Grid item xs={6}>
          <MDInput
            type="date"
            label="Date of Upload"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={doc.dateofupload || ""}
            onChange={(e) => {
              const updatedDocs = [...customerDetails.document];
              updatedDocs[index] = {
                ...updatedDocs[index],
                documentname: docName,
                dateofupload: e.target.value,
              };
              setCustomerDetails({
                ...customerDetails,
                document: updatedDocs,
              });
            }}
            error={!!errors.dateofupload}
          />
          {errors.dateofupload && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errors.dateofupload}
            </Typography>
          )}
        </Grid> */}

        {/* File Upload */}
     <Grid item xs={6}>
  <Box display="flex" alignItems="center" gap={1}>
    {/* Hidden File Input */}
    <input
      accept="image/*,.pdf,.doc,.docx"
      type="file"
      id={`file-upload-${index}`}
      style={{ display: "none" }}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check duplicate
        const duplicate = customerDetails.document.some(
          (d, idx) => d.documentname === docName && idx !== index
        );
        const updatedDocs = [...customerDetails.document];
        if (duplicate) {
          updatedDocs[index] = {
            ...updatedDocs[index],
            errors: { ...updatedDocs[index]?.errors, duplicate: "This document is already uploaded" },
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
          return;
        } else {
          updatedDocs[index] = {
            ...updatedDocs[index],
            documentname: docName,
            errors: { ...updatedDocs[index]?.errors, duplicate: "" },
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        }

        // Read file as base64
        const reader = new FileReader();
        reader.onloadend = () => {
          const updatedDocs = [...customerDetails.document];
          updatedDocs[index] = {
            ...updatedDocs[index],
            documentname: docName,
            imageMeta: file.name,
            image: reader.result.split(",")[1], // store base64
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        };
        reader.readAsDataURL(file);
      }}
    />

    {/* Choose File Button */}
    <label htmlFor={`file-upload-${index}`}>
      <MDButton
        component="span"
        variant="outlined"
        sx={{
          textTransform: "none",
          color: "#1e6a91",
          borderColor: "#1e6a91",
          height: "40px",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Choose File
      </MDButton>
    </label>

    {/* File Name Link */}
    {doc.imageMeta && (
      <Typography
        sx={{
          color: "#1e6a91",
          cursor: "pointer",
          textDecoration: "underline",
                      fontSize: "13px",

          flexShrink: 0,
        }}
        onClick={() => {
          const ext = doc.imageMeta.split(".").pop().toLowerCase();
          const byteCharacters = atob(doc.image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Determine MIME type
          let mimeType = "application/octet-stream";
          if (["jpg", "jpeg"].includes(ext)) mimeType = "image/jpeg";
          else if (ext === "png") mimeType = "image/png";
          else if (ext === "gif") mimeType = "image/gif";
          else if (ext === "pdf") mimeType = "application/pdf";
          else if (ext === "doc") mimeType = "application/msword";
          else if (ext === "docx") mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          // Open in new tab for images & PDFs, download for Word docs
          if (["jpg", "jpeg", "png", "gif", "pdf"].includes(ext)) {
            window.open(url, "_blank");
          } else {
            const a = document.createElement("a");
            a.href = url;
            a.download = doc.imageMeta;
            a.click();
          }
        }}
      >
        {doc.imageMeta}
      </Typography>
    )}

    {/* Delete Icon */}
    {doc.imageMeta && (
      <IconButton
        size="small"
        color="error"
        onClick={() => {
          const updatedDocs = [...customerDetails.document];
          updatedDocs[index] = {
            ...updatedDocs[index],
            imageMeta: "",
            image: "",
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        }}
                  sx={{ p: 0 }}

      >
          <DeleteIcon sx={{ fontSize: 18 }} />
      </IconButton>
    )}
  </Box>

  {/* Duplicate Error */}
  {doc.errors?.duplicate && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {doc.errors.duplicate}
    </Typography>
  )}
</Grid>



        {/* Aadhaar Verification */}
        {docName === "Aadhar Card" && !doc.verified && (
          <Grid item xs={12}>
            <MDButton
              variant="outlined"
              onClick={() => {
                window.open("https://myaadhaar.uidai.gov.in/", "_blank");
                const updatedDocs = [...customerDetails.document];
                updatedDocs[index] = {
                  ...updatedDocs[index],
                  verified: true,
                };
                setCustomerDetails({
                  ...customerDetails,
                  document: updatedDocs,
                });
              }}
              sx={{
                background: "#1e6a91",
                color: "#fff",
                "&:hover": { background: "#1e6a91" },
                mt: 1,
              }}
            >
              Verify Aadhaar
            </MDButton>
          </Grid>
        )}
      </Grid>
    );
  }
)}






       
              </Grid>

              <MDBox mt={2} textAlign="center">
                <MDButton variant="gradient"  type="submit"  
                  sx={{
      background: "#2e7faeff !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#2e7faeff !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
      },
    }}>Submit</MDButton>&emsp;
                <MDButton variant="gradient"  onClick={handleCancel}  
                 sx={{
      background: "#2e7faeff !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#2e7faeff !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
      },
    }} >Cancel</MDButton>
              </MDBox>
            </form>
          </MDBox>
        </Card>
      
     
    </DashboardLayout>
  );
}

export default CreateCareCoordinators;

